let title = ' | Gestor - Comercial Ivaiporã'

const cd = {
    path: '/cd',
    props: true,
    component: () => import('@/Components/Cd/CdContainer'),
    children: [
        {
            path: '',
            name: 'CdEstoque',
            component: () => import('@/Components/Cd/CdEstoque.vue'),
            meta: {
                title: 'CD' + title,
                permission: 'cd_menu',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Estoque e Reserva de Produtos',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/cd',
                    }
                ]
            }
        },
        {
            path: 'Dashboard',
            name: 'CdDashboard',
            component: () => import('@/Components/Cd/CdDashboard'),
            meta: {
                title: 'CD' + title,
                permission: 'cd_dashboard',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Power BI',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/cd',
                    }
                ]
            }
        },
    ]
}

export default cd